import { setRemoteDef } from "./ModuleLoader";

fetch("/importmap.json")
  .then((res) => res.json())
  .then((r) => setRemoteDef(r))
  .then(() => import("./bootstrap"))
  .catch((err) => console.error(err));
